export default {
      MyOrdersHistory: 'الطلب المغلق|طلباتي المغلقة',
      MyOrdersHistory_no_body: 'طلب مغلق',
};
